// This is run in legacy and therefore inlines its dependencies
// when compiled (see rollup.config.js)

import { init } from "./b2x-script-loader";
init();
